import { render } from "./NewDelivery.vue?vue&type=template&id=600fb3c2&scoped=true"
import script from "./NewDelivery.vue?vue&type=script&lang=js"
export * from "./NewDelivery.vue?vue&type=script&lang=js"

import "./NewDelivery.vue?vue&type=style&index=0&id=600fb3c2&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600fb3c2"]])

export default __exports__